/**
 * Asynchronously loads the component for AdminEmployers
 */

import { lazyLoad } from "utils/loadable";

export const AdminEmployers = lazyLoad(
  () => import("./index"),
  (module) => module.AdminEmployers
);
